// extracted by mini-css-extract-plugin
export default {"compositionCards":"CompositionOfSuperiors_compositionCards__wh+48"};